module.exports = __webpack_public_path__ + "static/img/bgimg5-1.6bb7c5c4.png";